




import { Component, Vue } from 'vue-property-decorator';
import { SystemApi } from 'performo-api';

@Component({ components: {} })
export default class VersionInformation extends Vue {
  private sysApi: SystemApi = new SystemApi(
    this.$store.getters.getApiConfiguration
  );
  private versions: {
    [key: string]: string;
  } = {};

  private async mounted() {
    this.versions = await this.sysApi.versionInformation();
  }
}
